/** Read a File as a data URL with FileReader or ArrayBuffer fallback. */

function arrayBufferToDataUrl(buffer: ArrayBuffer, mimeType: string): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  if (typeof btoa !== 'function') {
    throw new Error('Base64 encoding is not supported in this browser');
  }
  return `data:${mimeType || 'application/octet-stream'};base64,${btoa(binary)}`;
}

export function readFileAsDataUrl(file: File): Promise<string> {
  if (typeof FileReader !== 'undefined') {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(typeof reader.result === 'string' ? reader.result : '');
      };
      reader.onerror = () => {
        reject(reader.error || new Error('Failed to read file'));
      };
      reader.readAsDataURL(file);
    });
  }

  if (typeof file.arrayBuffer === 'function') {
    return file
      .arrayBuffer()
      .then((buffer) => arrayBufferToDataUrl(buffer, file.type));
  }

  if (typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function') {
    const objectUrl = URL.createObjectURL(file);
    return fetch(objectUrl)
      .then((res) => res.arrayBuffer())
      .then((buffer) => arrayBufferToDataUrl(buffer, file.type))
      .finally(() => {
        URL.revokeObjectURL(objectUrl);
      });
  }

  return Promise.reject(
    new Error('File reading is not supported in this browser'),
  );
}
